module.exports = __webpack_public_path__ + "static/media/signUpScreen.4740e609.png";